<template>
  <a-modal
    ref="createModal"
    title="新增工单分类"
    :width="850"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 900, y: 260 }"
    >
      <!-- 加工组织 -->
      <span slot="organizationCodeTitle">
        <i class="toRequired">*</i>加工组织
      </span>
      <template slot="organizationCode" slot-scope="text, record">
        <global-select
          :value.sync="record.organizationCode"
          selectType="selectAssembleSearch"
          requestApi="/system/user/inventOrgList"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :dropdown-match-select-width="false"
          searchParam="organizationName"
          :allowClear="false"
          :assembleLabel="true"
          @change="(val, list) => organizationCodeChange(val, list, record)"
        />
      </template>

      <template slot="jobClassDesc" slot-scope="text, record">
        <a-input v-model="record.jobClassDesc" />
      </template>
      <!-- 工单分类 -->
      <span slot="jobClassTitle">
        <i class="toRequired">*</i>工单分类
      </span>
      <template slot="jobClass" slot-scope="text, record">
        <global-select
          :value.sync="record.jobClass"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'MES_JOB_CLASS' }"
          :allowClear="false"
          @change="(val, list) => jobClassChange(val, list, record)"
        />
      </template>
      <!-- 工单分类编码 -->
      <span slot="jobClassCodeTitle">
        <i class="toRequired">*</i>工单分类编码
      </span>
      <template slot="jobClassCode" slot-scope="text, record">
        <a-input v-model="record.jobClassCode" />
      </template>
      <!-- 工单类型 -->
      <span slot="jobTypeTitle">
        <i class="toRequired">*</i>工单类型
      </span>
      <template slot="jobType" slot-scope="text, record">
        <a-select v-model="record.jobType">
          <a-select-option v-for="(item) in jobTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiJobClassAdd } from '@/api/mes/basedata/jobclass'
// 表单字段
export default {
  props: {
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '加工组织',
          width: 150,
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode', title: "organizationCodeTitle" }
        },
        {
          // title: '工单分类',
          width: 150,
          dataIndex: 'jobClass',
          scopedSlots: { customRender: 'jobClass', title: "jobClassTitle" }
        },
        {
          // title: '工单分类编码',
          width: 150,
          dataIndex: 'jobClassCode',
          scopedSlots: { customRender: 'jobClassCode', title: "jobClassCodeTitle" }
        },
        {
          title: '说明',
          width: 150,
          dataIndex: 'jobClassDesc',
          scopedSlots: { customRender: 'jobClassDesc' }
        },
        {
          // title: '工单类型',
          width: 160,
          dataIndex: 'jobType',
          scopedSlots: { customRender: 'jobType', title: "jobTypeTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: "right"
        }
      ],
      typeList: [],
      jobTypeOptions: [] // 工单类型
    }
  },
  created () {
    const jobTypeOptionsParams = {
      lookupType: 'MES_JOB_TYPE',
      current: 1,
      pageSize: 100
    }
    this.getLookupListData(jobTypeOptionsParams).then().then(response => {
      this.jobTypeOptions = response.rows
    })
  },
  methods: {
    // 加工组织
    organizationCodeChange (val, list, record) {
      record.bringOutDataOne = this.$getFlagName(list, val, "realValue", "bringOutDataOne")
      record.bringOutDataTwo = this.$getFlagName(list, val, "realValue", "bringOutDataTwo")
      if (record.organizationCode && record.jobClass) {
        record.jobClassCode = `${record.bringOutDataOne}${record.jobClass}`
        record.jobClassDesc = `${record.bringOutDataTwo}${record.jobClassNew}`
      }
    },
    // 工单分类
    jobClassChange (val, list, record) {
      record.jobClassNew = this.$getFlagName(list, val, "lookupCode", "lookupValue")
      if (record.organizationCode && record.jobClass) {
        record.jobClassCode = `${record.bringOutDataOne}${record.jobClass}`
        record.jobClassDesc = `${record.bringOutDataTwo}${record.jobClassNew}`
      }
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        bringOutDataOne: "",
        bringOutDataTwo: "",
        organizationCode: "",
        jobClassCode: "",
        jobClassDesc: "",
        jobClass: "",
        jobClassNew: "",
        jobType: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].organizationCode || !this.typeList[i].jobClassCode || !this.typeList[i].jobType) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiJobClassAdd(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
